import React from 'react';
import { StructureLeftRightWrapper } from '../../../MyTeamBackofficeStyled';
import { DotLineArrows, LevelTwo } from '../../common';
import { useSelector } from 'react-redux';
import StructureNav from './StructureNav.js';
import { LevelZero } from './LevelZero/LevelZero.js';
import { Position } from '../../../myTeamBackOffice.constants';

const StructureMobile = () => {
  const { rootTeamMember } = useSelector((store) => store.myTeamBackoffice);

  return (
    <>
      <div>
        <LevelZero />
        <DotLineArrows />
        <StructureLeftRightWrapper style={{ marginBottom: '100px' }}>
          <div>
            <LevelTwo
              teamMember={rootTeamMember?.leftChildUser}
              parentId={rootTeamMember?.id}
              position={Position.L}
            />
            <DotLineArrows disabled={!rootTeamMember?.leftChildUser?.id} />
            <StructureLeftRightWrapper>
              <div>
                <LevelTwo
                  teamMember={rootTeamMember?.leftChildUser?.leftChildUser}
                  parentId={rootTeamMember?.leftChildUser?.id}
                  position={Position.L}
                />
              </div>
              <div>
                <LevelTwo
                  teamMember={rootTeamMember?.leftChildUser?.rightChildUser}
                  parentId={rootTeamMember?.leftChildUser?.id}
                  position={Position.R}
                />
              </div>
            </StructureLeftRightWrapper>
          </div>
          <div>
            <LevelTwo
              teamMember={rootTeamMember?.rightChildUser}
              parentId={rootTeamMember?.id}
              position={Position.R}
            />
            <DotLineArrows disabled={!rootTeamMember?.rightChildUser?.id} />
            <StructureLeftRightWrapper>
              <div>
                <LevelTwo
                  teamMember={rootTeamMember?.rightChildUser?.leftChildUser}
                  parentId={rootTeamMember?.rightChildUser?.id}
                  position={Position.L}
                />
              </div>
              <div>
                <LevelTwo
                  teamMember={rootTeamMember?.rightChildUser?.rightChildUser}
                  parentId={rootTeamMember?.rightChildUser?.id}
                  position={Position.R}
                />
              </div>
            </StructureLeftRightWrapper>
          </div>
        </StructureLeftRightWrapper>
      </div>

      <StructureNav />
    </>
  );
};

export default StructureMobile;
